.inlineIcon {
  vertical-align: middle;
}

.button {
  margin-block: var(--space-1) calc(-1 * var(--space-2));
}
